import React from 'react';
import Styles from './credit-card-score-styles.scss';
import classNames from 'classnames';
const scoreRanges = [
    { state: '300 - 579', minScore: 300, maxScore: 579, message: 'Poor', color: '#f04a4a' },
    { state: '580 - 669', minScore: 580, maxScore: 669, message: 'Fair', color: '#F48218' },
    { state: '670 - 739', minScore: 670, maxScore: 739, message: 'Good', color: '#FFB800' },
    { state: '740 - 799', minScore: 740, maxScore: 799, message: 'Very Good', color: '#85CB82' },
    { state: '800 - 850', minScore: 800, maxScore: 850, message: 'Excellent', color: '#65C702' }
];
const CreditScoreText = ({ score = 0 }) => {
    const getValueByScore = (score) => {
        const scoreRange = scoreRanges.find(range => score >= range.minScore && score <= range.maxScore);
        if (scoreRange) {
            return {
                state: scoreRange.state,
                message: scoreRange.message,
                color: scoreRange.color
            };
        }
    };
    const values = getValueByScore(score);
    if (values) {
        return (React.createElement("div", { className: Styles.creditScoreText, style: { color: values.color } },
            score,
            " (",
            values.message,
            ")"));
    }
    return React.createElement("div", { className: classNames(Styles.creditScoreText, Styles.creditScoreTextempty) }, "0 (Empty score)");
};
export default CreditScoreText;
